/**
 * 侧边导航配置
 */
const siderBar = [
  {
    index: '/project',
    title: '项目管理',
    roles: [1, 2, 4, 5, 6, 7, 8]
  },
  {
    index: '/schedule',
    title: '排期管理',
    roles: [1, 2, 3]
  },
  {
    index: '/finance',
    title: '提成结算',
    roles: [1, 6, 8]
  },
  {
    index: '/statistics',
    title: '数据统计',
    roles: [1, 2, 3],
    child: [
      {
        index: '/report',
        title: '原始数据',
        roles: [1, 2, 3]
      },
      {
        index: '/analyse',
        title: '数据分析',
        roles: [1, 2]
      }
    ]
  },
  {
    index: '/resource',
    title: '资源管理',
    roles: [1, 2, 4, 5, 8]
  },
  // {
  //   index: '/analyse',
  //   title: '数据分析',
  //   roles: [1, 2]
  // },
  // {
  //   index: '/finance',
  //   title: '财务结算',
  //   roles: [1, 2, 4, 5, 6]
  // },
  {
    index: '/company',
    title: '人员管理',
    roles: [1]
  },
  {
    index: '/account',
    title: '账号管理',
    roles: []
  },
  {
    index: '/plugin',
    title: '插件下载',
    roles: [1, 2, 3]
  }
]

/**
 * 路由
 */
const routes = [
  {
    path: '/',
    name: 'Schedule',
    component: resolve => require(['@/pages/schedule/page/Schedule.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 2, 3]
    }
  },
  {
    path: '/project',
    name: 'Project',
    component: resolve => require(['@/pages/project/page/Project.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 2, 4, 5, 6, 7, 8]
    }
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: resolve => require(['@/pages/schedule/page/Schedule.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 2, 3]
    }
  },
  {
    path: '/resource',
    name: 'Resource',
    component: resolve => require(['@/pages/resource/page/Resource.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 2, 4, 5, 8]
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: resolve => require(['@/pages/report/page/Report.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 2, 3]
    }
  },
  {
    path: '/analyse',
    name: 'Analyse',
    component: resolve => require(['@/pages/analyse/page/Analyse.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 2]
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: resolve => require(['@/pages/account/page/Account.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: resolve => require(['@/pages/account/page/Login.vue'], resolve),
    meta: {
      // keepAlive: true
      needLogin: false
    }
  },
  {
    path: '/plugin',
    name: 'Plugin',
    component: resolve => require(['@/pages/plugin/page/Plugin.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 2, 3]
    }
  },
  {
    path: '/pq/:hash',
    name: 'scheduleView',
    component: resolve => require(['@/pages/scheduleView/page/ScheduleView'], resolve),
    meta: {
      keepAlive: true,
      needLogin: false
    }
  },
  {
    path: '/company',
    name: 'Company',
    component: resolve => require(['@/pages/company/page/Company.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1]
    }
  },
  {
    path: '/finance',
    name: 'Finance',
    component: resolve => require(['@/pages/finance/page/Finance.vue'], resolve),
    meta: {
      keepAlive: true,
      needLogin: true,
      roles: [1, 6]
    }
  },
  {
    path: '/plannercheck',
    name: 'PlannerCheck',
    component: resolve => require(['@/pages/other/page/PlannerCheck.vue'], resolve),
    meta: {
      // keepAlive: true
      // needLogin: false
    }
  },
  {
    path: '/businesscheck',
    name: 'BusinessCheck',
    component: resolve => require(['@/pages/other/page/BusinessCheck.vue'], resolve),
    meta: {
      // keepAlive: true
      // needLogin: false
    }
  }
]

export default {siderBar, routes}



// WEBPACK FOOTER //
// ./src/router/config.js